<template>
    <fade-animation>
    <div class="iframe_box" v-if="showIframe" @click="closeIframe">
        <div class="main">
        <img src="../assets/images/img_guide_arrows.png" alt />
        <div class="main_text">
            <p>点击右上角</p>
            <p>分享微信好友或朋友圈</p>
        </div>
        </div>
    </div>
    </fade-animation>
</template>

<script>
import FadeAnimation from './FadeAnimation.vue'
export default {
  name: "shareIframe",
  props:{
      showIframe:{
          type:Boolean,
          default:false
      }
  },
  components:{
      FadeAnimation
  },
  methods:{
      closeIframe(){
          this.$emit("hideIframe")
      }
  }
};
</script>

<style lang="less" scoped>
.iframe_box {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  .main {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    padding-right: 60px;
    padding-top: 28px;
    img {
      display: block;
      width: 120px;
      height: 146px;
    }
    .main_text {
      text-align: center;
      color: #fff;
      font-size: 32px;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
    }
  }
}
</style>